import { useAuth } from '@acin/user-accounts';
import React from 'react';

export const Login = () => {
  const { isAuthenticated, loading, login, logout } = useAuth();

  React.useEffect(() => {
    if (!loading) {
      if (!isAuthenticated && !window.location.pathname.endsWith('/auth')) {
        login();
      } else if (isAuthenticated) {
        logout();
      }
    }
  }, [login, logout, isAuthenticated, loading]);

  return null;
};
